import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
  selectAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/twUniversity/findAll`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
}
